import { axios } from '@/services/axios';

const getCarrier = (carrierId) => {
    return axios.get(`/carrier/${carrierId}`);
};

export default getCarrier;
